<div class="m-3 flex flex-col" lohiPageTitle="Shift Daily Cap" [formGroup]="lookupForm">
  <h2>Shift Daily Cap Management</h2>

  <div class="grid grid-cols-4 gap-x-2 card-with-shadow bg-white p-2">
    <!-- Carrier Selector -->
    <mat-form-field class="w-full">
      <mat-label>Carrier</mat-label>
      <mat-select (opened)="searchInput.focus()" [formControl]="companyPicker" class="w-full">
        <mat-form-field class="w-full p-1">
          <input type="text" matInput [formControl]="companySearch" autocomplete="off" #searchInput
                 (keydown)="$event.stopPropagation()" />
        </mat-form-field>
        <mat-option *ngFor="let company of companies$ | async; trackBy: 'id' | trackByKey" [value]="company.id">
          {{ company.name }} ({{ company.id }})
        </mat-option>
      </mat-select>
    </mat-form-field>


    <!-- Date Range Selector -->
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker" [disabled]="companyPicker.value === null">
        <input matStartDate [formControl]="start" placeholder="Start date" #dateRangeStart>
        <input matEndDate [formControl]="end" placeholder="End date" #dateRangeEnd
               (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <div class="card-with-shadow bg-white p-2 mt-2">
    <div class="grid grid-cols-7 gap-y-4 gap-x-2">
      <div *ngFor="let capData of dailyCaps$$ | async; trackBy: 'id' | trackByKey">
        <lohi-cap-form-field-component [capData]="capData"></lohi-cap-form-field-component>
      </div>
    </div>
    <div class="mt-2">
      <button mat-raised-button color="primary" (click)="submit()">
        Save
      </button>
    </div>

  </div>
</div>
